import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Thumbnail } from 'ionic-angular';
import { SingleMarketPlacePage } from '../single-market-place/single-market-place';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';
import { MarketplaceAddOfferPage } from '../marketplace-add-offer/marketplace-add-offer'
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MarketplacecategoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@IonicPage()
@Component({
  selector: 'page-marketplacecategory',
  templateUrl: 'marketplacecategory.html',
})
export class MarketplacecategoryPage {
  fakeCategory: Array<any> = new Array(1);

  name: any;
  user_tenant=false;
  uuid:any;
  marketuuid:any;
  param:any;
  categoryItems=[];
  societyuuid:any;
  viewOfferName : any;
  userList:any;

  constructor(public navCtrl: NavController,
     public navParams: NavParams,
     private translate: TranslateService,
     private marketplaceprovider: MarketplaceProvider,
     private storage: Storage){
      this.storage.get("loginDetails").then(val => {
        if(val.tenant){
          this.user_tenant = val.tenant;
        }
      });
    
      this.userList = this.navParams.get("userList");
      this.name = this.navParams.get("name");
      this.marketuuid = this.navParams.get("marketuuid");
      this.societyuuid =this.navParams.get("societyuuid");
      this.uuid = this.navParams.get("uuid");
       console.log(this.marketuuid);
       console.log(this.uuid);
       this.param=undefined;
       this.allOffer();
  }

  allOffer(){
    this.marketplaceprovider.getAllItem(this.marketuuid,this.uuid,this.param).then(val => {
      this.categoryItems = val['data'];  
      this.viewOfferName = ""        
 });
  }

  residentOfferView(block){
    this.marketplaceprovider.getResidentOffer(this.societyuuid,block).then(val => {
      console.log(val)
      this.categoryItems = val['data'];
      if(block == 0){
        this.viewOfferName = "MY_PUBLISH_OFFER"
      }    
      else{
        this.viewOfferName = "MY_BLOCK_OFFER" 
      }    
      });
 }

  singlePage(item){
      this.clickItem(this.societyuuid,this.marketuuid,this.uuid,item.uuid);
    console.log(item)
    this.navCtrl.push(SingleMarketPlacePage, {
      societyuuid:this.societyuuid,
      marketuuid:this.marketuuid,
      categoryuuid:this.uuid,
      itemid:item.uuid,
      itemSingle:item,
      categoryName : this.name,
      userList : this.userList,
    });
  }
  
  createOffer(){
    this.navCtrl.push(MarketplaceAddOfferPage,{
      societyuuid:this.societyuuid,
      marketuuid:this.marketuuid,
      categoryuuid:this.uuid,
      categoryName :this.name,
      userList : this.userList
    });
  }


  clickItem(societyuuid,marketuuid,categoryid,id){
    this.marketplaceprovider.click(societyuuid,marketuuid,categoryid,id).then(val => {
      console.log(val['status'],"status");
        if(val['status'] == 'success'){
         this.allOffer()
    }
    });
  };


  


  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplacecategoryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplacecategory/marketplacecategory.ts